import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-application"},[_c(VSnackbar,{attrs:{"timeout":_vm.snackbar.timeout,"right":"","color":_vm.snackbar.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.snackbar.text)+" "),(_vm.snackbar.button)?_c(VBtn,{attrs:{"color":_vm.snackbar.color ? '' : 'blue darken-1',"text":""},on:{"click":function($event){_vm.show = false}}},[_vm._v(" Fechar ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }